import { API_BASE_URL } from '../config';
import { BantQualification } from '../types';

export interface FetchBantOptions {
  page?: number;
  size?: number;
}

export interface BantListResponse {
  data: BantQualification[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  size: number;
}

export async function fetchBantQualifications(
  accessToken: string,
  options?: FetchBantOptions
): Promise<BantListResponse> {
  const params = new URLSearchParams();

  if (options?.page !== undefined) {
    params.append('page', options.page.toString());
  }

  if (options?.size !== undefined) {
    params.append('size', options.size.toString());
  } else {
    params.append('size', '100'); // Default to 100 items
  }

  const queryString = params.toString();
  const endpoint = `${API_BASE_URL}/backoffice/bant/qualifications${queryString ? '?' + queryString : ''}`;

  const response = await fetch(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar qualificacoes BANT');
  }

  const payload = await response.json();
  // API wraps response in { success, data, error } via ResponseWrapperFilter
  const innerData = payload.data || {};
  return {
    data: innerData.data || [],
    totalElements: innerData.totalItems || 0,  // API uses 'totalItems'
    totalPages: innerData.totalPages || 0,
    currentPage: innerData.page || 0,  // API uses 'page'
    size: innerData.size || 100
  };
}

export async function fetchBantQualificationByChatId(
  chatId: string,
  accessToken: string
): Promise<BantQualification> {
  const response = await fetch(`${API_BASE_URL}/backoffice/bant/qualifications/${chatId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar qualificacao BANT');
  }

  const payload = await response.json();
  return payload;  // API returns object directly, not wrapped in { data: ... }
}

export async function deleteBantQualification(
  chatId: string,
  accessToken: string
): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/backoffice/bant/qualifications/${chatId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao deletar qualificacao BANT');
  }
}
